import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import { captureException } from 'utils/SentryHelpers'
import { api } from './api'
import * as actions from './actions'
import * as selectors from './selectors'
import * as helpers from 'utils/SegmentSelectHelper'
import * as OrgSelectors from 'app/modules/org/selectors'
function fetchSegmentList(action$) {
  return action$
    .ofType(actions.fetchSegmentList.toString())
    .switchMap(() => {
      return api
        .fetchList()
        .map(actions.receiveSegmentList)
        .startWith(actions.fetchSegmentListPending())
        .catch(error => {
          captureException(error)
          return Observable.of(actions.fetchSegmentListFailed(error))
        })
    })
}

function fetchSegmentSetCardinality(action$) {
  return action$
    .ofType(actions.fetchSegmentSetCardinality.toString())
    .pluck('payload')
    .switchMap((userListIds) => {
      return api
        .fetchSegmentSetCardinality(userListIds)
        .map(res => res.response)
        .flatMap(response => {
          return [actions.receiveSegmentSetCardinality({ segmentSet: helpers.segmentIdsToSegmentSet(userListIds), cardinality: response.cardinality })]
        })
        .startWith(actions.fetchSegmentSetCardinalityPending)
        .catch(error => {
          return Observable.of(actions.fetchSegmentSetCardinalityFailed({ userListIds, error }))
        })
    })
}

function fetchEndUserMembership(action$, { getState }) {
  return action$
    .ofType(actions.fetchEndUserMembership.toString())
    .pluck('payload')
    .filter(({ endUserId }) => !selectors.endUserMembershipByIdFetched(getState(), endUserId))
    .mergeMap(({ endUserId }) => {
      const orgId = OrgSelectors.orgId(getState())
      return api.fetchEndUserMembership(endUserId, orgId)
        .map(res => res.response)
        .map(((membership) => actions.receiveEndUserMembership({ endUserId, membership })))
        .startWith(actions.fetchEndUserMembershipPending)
        .catch(error => Observable.of(actions.fetchEndUserMembershipFailed({ endUserId, error })))
    })
}

export const epic = combineEpics(
  fetchSegmentList,
  fetchSegmentSetCardinality,
  fetchEndUserMembership
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/segment/epic.js